/*
 *
 * HeyLightPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { useNavigate } from 'react-router-dom'
import './HeyLightPopup.scss'

const HeyLightPopup = (props) => {
  const navigate = useNavigate()

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.title}
        description={formattedMessage.description}
        ariaModalDescription={formattedMessage.description}
        ariaModalTitle={formattedMessage.title}
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => {
          props.actions.doHidePopup()
          navigate('/services/change-pos/terminal-selection')
        }}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
      />
    </Toggle>
  )
}

HeyLightPopup.propTypes = {
  actions: PropTypes.object.isRequired
}

HeyLightPopup.defaultProps = {
  actions: {}
}

export default HeyLightPopup
